
import { Component, Vue } from 'vue-property-decorator'
import TemplateSelector from '@/components/generic/TemplateSelector.vue'
import { Template } from '@/types/Templates'
import templatesService from '@/services/TemplatesService'

@Component({
  components: {
    TemplateSelector
  }
})
export default class FillgridTemplate extends Vue {
  Template = Template
  historyTemplates: Template[] = templatesService.getLatestSelectedTemplatesForTracking()

  templateSelected: string = ''

  selectTemplate (template: Template) {
    this.$router.push({ name: 'fillgridData', params: { id: template.id.toString() } })
    templatesService.addItemToLatestSelectedTemplatesForTracking(template)
  }
}
